<template>
  <div class="learning-path-overview">
    <div class="row mb-2">
      <div class="col-12 col-sm-4 col-attribute">Required Courses:</div>
      <div class="col-12 col-sm-8 col-value">{{ requiredCourses }}</div>
    </div>
    <div v-if="!!learningPath.hours" class="row mb-2">
      <div class="col-12 col-sm-4 col-attribute">Hours:</div>
      <div class="col-12 col-sm-8 col-value" v-html="learningPath.hours"></div>
    </div>
    <div class="row mb-2">
      <div class="col-12 col-sm-4 col-attribute">
        {{ learningPath.discount > 0 ? "* " : "" }}Pricing:
      </div>
      <div
        class="col-12 col-sm-8 col-value"
        v-html="learningPath.pricing"
      ></div>
    </div>
    <div v-if="learningPath.discount > 0" class="row mb-2">
      <div class="col-12 col-sm-4 col-attribute">Discount:</div>
      <div class="col-12 col-sm-8 col-value">
        A {{ learningPath.discount }}% discount will be applied when purchasing
        this learning path
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12 col-sm-4 col-attribute">Path Expiration:</div>
      <div
        class="col-12 col-sm-8 col-value"
        v-html="learningPath.expiration"
      ></div>
    </div>
    <div v-if="learningPath.show_test_url" class="row mb-2">
      <div class="col-12 col-sm-4 col-attribute">Test:</div>
      <div class="col-12 col-sm-8 col-value">
        <a
          v-if="learningPath.test_available"
          :href="learningPath.test_url"
          class="text-primary"
          target="_blank"
          >{{ learningPath.test_name || "Take Test" }}</a
        >
        <a
          v-else
          href="#"
          @click.prevent="showTestUnavailableAlert()"
          class="text-primary"
          >{{ learningPath.test_name || "Take Test" }}</a
        >
      </div>
    </div>
    <div v-if="!!learningPath.survey_url" class="row mb-2">
      <div class="col-12 col-sm-4 col-attribute">Survey:</div>
      <div class="col-12 col-sm-8 col-value">
        <a
          :href="learningPath.survey_url"
          class="text-primary"
          target="_blank"
          >{{ learningPath.survey_name || "Take Survey" }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    learningPath: { type: Object, required: true },
  },
  computed: {
    requiredCourses() {
      var text = "";
      if (this.learningPath.online_courses > 0) {
        text += text.length > 0 ? ", " : "";
        text += `${this.learningPath.online_courses} Online`;
      }
      if (this.learningPath.classroom_courses > 0) {
        text += text.length > 0 ? ", " : "";
        text += `${this.learningPath.classroom_courses} Classroom`;
      }
      return text;
    },
  },
  methods: {
    showTestUnavailableAlert() {
      this.$modal("AlertModal", {
        alert: {
          type: "info",
          message:
            "This test is currently unavailable. Please complete all required courses before attempting the test.",
        },
      })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>